<template>
  <div
    v-if="pickedCallTarget"
    class="current-call-target-container"
  >
    <LeadCard
      v-if="pickedCallTarget"
      :call-target="pickedCallTarget"
      :attribute-keys="attributeKeys"
      class="current-call-target"
      :expandable="false"
      default-expanded
      closable
      @click:close="handleClosePickedCallTarget"
    />
  </div>
  <LeadCard
    v-for="callTarget in otherCallTargets"
    :key="callTarget.id"
    :call-target="callTarget"
    :attribute-keys="attributeKeys"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { CallTarget } from '@/api/openapi';
import LeadCard from './LeadCard.vue';

type TProps = {
  callTargets: CallTarget[];
  attributeKeys: string[];
};

const props = defineProps<TProps>();

const pickedCallTargetId = defineModel<number>('pickedCallTargetId');

const pickedCallTarget = computed(() => props.callTargets.find((callTarget) => callTarget.id === pickedCallTargetId.value));
const otherCallTargets = computed(() => props.callTargets.filter((callTarget) => callTarget.id !== pickedCallTargetId.value));

const handleClosePickedCallTarget = () => {
  pickedCallTargetId.value = undefined;
};
</script>

<style lang="scss" scoped>
h3 {
  margin-bottom: $basespace-200;
  font-size: $fontsize-200;
}
.current-call-target {
  margin-bottom: $basespace-400;
  box-shadow: 0 1px 6px 0 $shadowcolor-base;
  :deep(.expandable-card-header), :deep(.expandable-card-content) {
    border-left: 2px solid $basecolor-accent;
  }
}
</style>
